import React from "react"
import ExtraAccountingForm from './Form'

export default function ExtraLoanAccountingDetails() {
  return <ExtraAccountingForm isUpdate={ false } />
}



// WEBPACK FOOTER //
// ./src/components/Accounting/ExtraAccounting/Details.js